import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { astFromValue, print } from "graphql";
import { ChevronDownIcon, ChevronUpIcon, Button } from "@graphiql/react";
import { DeprecationReason } from "./deprecation-reason.js";
import { TypeLink } from "./type-link.js";
import { renderType } from "./utils.js";
/* empty css                   */
const ArgumentsList = (t0) => {
  const $ = c(18);
  const {
    title,
    args
  } = t0;
  const [expanded, setExpanded] = useState(true);
  if (args.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setExpanded(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== expanded) {
    t2 = expanded ? /* @__PURE__ */ jsx(ChevronDownIcon, { "aria-hidden": "true" }) : /* @__PURE__ */ jsx(ChevronUpIcon, { "aria-hidden": "true" });
    $[1] = expanded;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== args.length) {
    t3 = /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-arguments-list-count", children: [
      "· ",
      args.length
    ] });
    $[3] = args.length;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3 || $[6] !== title) {
    t4 = /* @__PURE__ */ jsxs("span", { children: [
      title,
      " ",
      t3
    ] });
    $[5] = t3;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== expanded || $[9] !== t2 || $[10] !== t4) {
    t5 = /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-doc-explorer-arguments-list-header", onClick: t1, "aria-expanded": expanded, children: [
      t2,
      t4
    ] });
    $[8] = expanded;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== args || $[13] !== expanded) {
    t6 = expanded && /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-arguments-list-body", children: args.map(_temp2) });
    $[12] = args;
    $[13] = expanded;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-arguments-list", children: [
      t5,
      t6
    ] });
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
const ShowDeprecatedArgumentsButton = (t0) => {
  const $ = c(2);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick) {
    t1 = /* @__PURE__ */ jsx(Button, { type: "button", onClick, className: "graphiql-doc-explorer-arguments-list-show-deprecated", children: "Show Deprecated Arguments" });
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const ArgumentRow = (t0) => {
  const $ = c(34);
  const {
    arg
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== arg.defaultValue || $[1] !== arg.deprecationReason || $[2] !== arg.name || $[3] !== arg.type) {
    const defaultAst = arg.defaultValue === void 0 ? null : astFromValue(arg.defaultValue, arg.type);
    const isDeprecated = Boolean(arg.deprecationReason);
    const t72 = isDeprecated ? "graphiql-doc-explorer-argument--deprecated" : "";
    let t82;
    if ($[10] !== t72) {
      t82 = ["graphiql-doc-explorer-argument", t72].filter(Boolean);
      $[10] = t72;
      $[11] = t82;
    } else {
      t82 = $[11];
    }
    t6 = t82.join(" ");
    t1 = "graphiql-doc-explorer-argument-sig";
    if ($[12] !== arg.name) {
      t2 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-argument-name", children: arg.name });
      $[12] = arg.name;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-argument-colon", "aria-hidden": "true", children: ":" });
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t92;
    if ($[15] !== arg.type) {
      t92 = renderType(arg.type, _temp3);
      $[15] = arg.type;
      $[16] = t92;
    } else {
      t92 = $[16];
    }
    if ($[17] !== t92) {
      t4 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-argument-type", children: t92 });
      $[17] = t92;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    t5 = defaultAst && /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-argument-default", children: [
      "= ",
      print(defaultAst)
    ] });
    $[0] = arg.defaultValue;
    $[1] = arg.deprecationReason;
    $[2] = arg.name;
    $[3] = arg.type;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t7 = /* @__PURE__ */ jsxs("div", { className: t1, children: [
      t2,
      t3,
      t4,
      t5
    ] });
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== arg.description) {
    t8 = arg.description && /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-argument-desc", children: arg.description });
    $[25] = arg.description;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== arg.deprecationReason) {
    t9 = arg.deprecationReason ? /* @__PURE__ */ jsx(DeprecationReason, { preview: false, children: arg.deprecationReason }) : null;
    $[27] = arg.deprecationReason;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t10 = /* @__PURE__ */ jsxs("div", { className: t6, children: [
      t7,
      t8,
      t9
    ] });
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};
function _temp(e) {
  return !e;
}
function _temp2(arg) {
  return /* @__PURE__ */ jsx(ArgumentRow, { arg }, arg.name);
}
function _temp3(namedType) {
  return /* @__PURE__ */ jsx(TypeLink, { type: namedType });
}
export {
  ArgumentsList,
  ShowDeprecatedArgumentsButton
};
//# sourceMappingURL=arguments-list.js.map
